<template>
  <div class="box">
    <div class="rank-box rank-observe home-Progressive-hidden">
      <div class="box-title">
        <img
          style="width: 30rem; height: 5.5rem"
          src="../../assets/image/home/title.png"
          alt=""
        />
        <div class="title">虚仿软件</div>
      </div>
      <div class="rank-slider">
        <div class="model-rank-box">
        <div class="left-rank">
          <div>
            <p class="rank-title">人气排行</p>
            <img src="../../assets/image/home/mood.png" alt="" />
          </div>
          <div @mouseleave="changeMouseItem(null, 'currentMoodId')">
            <div
              v-for="(item, index) in moodRankList"
              :key="index"
              @click="toDetail(item)"
              @mouseover="changeMouseItem(item, 'currentMoodId')"
              class="model-item"
            >
              <div>
                <div class="rank" :class="'rank' + index">
                  {{ "0" + (index + 1) }}
                </div>
                <div class="rank-label overflow">{{ item.resName }}</div>
              </div>
              <div>
                <img
                  class="cover"
                  v-show="item.id == currentMoodId"
                  :src="
                    item.resPreviewUrl
                      ? $severUrl(item.resPreviewUrl)
                      : filterResDefault('虚拟仿真')
                  "
                  alt=""
                />
              </div>
            </div>
            <no-data v-if="moodRankList.length == 0"></no-data>
          </div>
        </div>
        <div class="left-rank">
          <div>
            <p class="rank-title">好评排行</p>
            <img src="../../assets/image/home/evaluate.png" alt="" />
          </div>
          <div @mouseleave="changeMouseItem(null, 'currentGoodId')">
            <div
              v-for="(item, index) in goodRankList"
              @click="toDetail(item)"
              @mouseover="changeMouseItem(item, 'currentGoodId')"
              :key="index"
              class="model-item"
            >
              <div>
                <div class="rank" :class="'rank' + index">
                  {{ "0" + (index + 1) }}
                </div>
                <div class="rank-label overflow">{{ item.resName }}</div>
              </div>
              <div>
                <img
                  class="cover"
                  v-show="item.id == currentGoodId"
                  :src="
                    item.resPreviewUrl
                      ? $severUrl(item.resPreviewUrl)
                      : filterResDefault('虚拟仿真')
                  "
                  alt=""
                />
              </div>
            </div>
            <no-data v-if="goodRankList.length == 0"></no-data>
          </div>
        </div>
        <div class="left-rank">
          <div>
            <p class="rank-title">点赞排行</p>
            <img src="../../assets/image/home/like.png" alt="" />
          </div>
          <div @mouseleave="changeMouseItem(null, 'currentLikeId')">
            <div
              v-for="(item, index) in likeRankList"
              @click="toDetail(item)"
              @mouseover="changeMouseItem(item, 'currentLikeId')"
              :key="index"
              class="model-item"
            >
              <div>
                <div class="rank" :class="'rank' + index">
                  {{ "0" + (index + 1) }}
                </div>
                <div class="rank-label overflow">{{ item.resName }}</div>
              </div>
              <div>
                <img
                  class="cover"
                  v-if="currentLikeId == item.id"
                  :src="
                    item.resPreviewUrl
                      ? $severUrl(item.resPreviewUrl)
                      : filterResDefault('虚拟仿真')
                  "
                  alt=""
                />
              </div>
            </div>
            <no-data v-if="likeRankList.length == 0"></no-data>
          </div>
        </div>
        <div v-if="$store.state.media.showSlider" class="left-rank">
          <div>
            <p class="rank-title">人气排行</p>
            <img src="../../assets/image/home/mood.png" alt="" />
          </div>
          <div @mouseleave="changeMouseItem(null, 'currentMoodId')">
            <div
              v-for="(item, index) in moodRankList"
              :key="index"
              @click="toDetail(item)"
              @mouseover="changeMouseItem(item, 'currentMoodId')"
              class="model-item"
            >
              <div>
                <div class="rank" :class="'rank' + index">
                  {{ "0" + (index + 1) }}
                </div>
                <div class="rank-label overflow">{{ item.resName }}</div>
              </div>
              <div>
                <img
                  class="cover"
                  v-show="item.id == currentMoodId"
                  :src="
                    item.resPreviewUrl
                      ? $severUrl(item.resPreviewUrl)
                      : filterResDefault('虚拟仿真')
                  "
                  alt=""
                />
              </div>
            </div>
            <no-data v-if="moodRankList.length == 0"></no-data>
          </div>
        </div>
        </div>
      </div>
      <div class="slider-spot" v-if="$store.state.media.showSlider">
        <div class="slider-item" :class="{'spot-active':currentIndex==index}" v-for="(item,index) in 3" :key="item" @click="changeRank(index)"></div>
      </div>
    </div>
    <div
      class="collage-box college-observe"
      v-if="!institutionTenantId"
    >
      <div class="left-slider"></div>
      <div class="center-box">
       <div class="college-box-item">
        <div
          v-for="(item, index) in collegeList"
          class="college-item"
          :key="index"
        >
          <img :src="$severUrl(item.coverUrl)" alt="" />
        </div>
       </div>
      </div>
      <div class="right-slider"></div>
    </div>
  </div>
</template>

<script>
import { GetDataRanking, GetHomeTenant } from "@/api/home";
import { filterResDefault } from "@/utils/utils";
import NoData from "../common/NoData.vue";
export default {
  components: { NoData },
  data() {
    return {
      institutionTenantId: sessionStorage.getItem("institutionTenantId") || "",
      /**人气排行 */
      moodRankList: [],
      /**好评排行 */
      goodRankList: [],
      /**点赞排行 */
      likeRankList: [],
      /**当前悬停人气榜Id */
      currentMoodId: "",
      /**当前悬停好评榜Id */
      currentGoodId: "",
      /**当前悬停点赞榜Id */
      currentLikeId: "",
      /**学校 */
      collegeList: [],
      /**轮播索引 */
      currentIndex:0,
      timer:null
    };
  },
  methods: {
    filterResDefault,
    /**移动端排行自动轮播 */
    autoSlider(){
      if(this.timer){
        return;
      };
      this.timer=setInterval(()=>{
        this.currentIndex++;
        let rankBox=document.querySelector('.model-rank-box');
        let width=rankBox.clientWidth;
        if(rankBox){
          rankBox.style.transition='all 0.5s';
          rankBox.style.transform=`translateX(-${this.currentIndex*width}px)`;
        }
        if(this.currentIndex==3){
          this.currentIndex=0;
          setTimeout(()=>{
            rankBox.style.transition='none';
            rankBox.style.transform='translateX(0)';
          },500);
        }
      },5000)
    },
    toDetail(item) {
      this.$router.push({
        path: "/virtualSimulation/detail",
        query: {
          id: item.id,
        },
      });
    },
    /**切换轮播排行 */
    changeRank(index){
      let rankBox=document.querySelector('.model-rank-box');
      rankBox.style.transition='all 0.5s';
      let width=rankBox.clientWidth;
      if(rankBox){
        this.currentIndex=index;
        this.timer&&clearInterval(this.timer);
        this.timer=null;
        this.autoSlider();
        rankBox.style.transform=`translateX(-${index*width}px)`;
      }
    },
    changeMouseItem(item, type) {
      if(this[type].length==0)return;
      if (!item) {
        var obj = {
          currentMoodId: this.moodRankList,
          currentGoodId: this.goodRankList,
          currentLikeId: this.likeRankList,
        };
        this[type] = obj[type][0].id;
        return;
      }
      this[type] = item.id;
    },
    /**获取数据排行 */
    getDataRanking(orderType) {
      GetDataRanking(orderType).then((res) => {
        if (res.code == 200) {
          var obj = {
            0: "moodRankList",
            1: "goodRankList",
            2: "likeRankList",
          };
          var obj1 = {
            0: "currentMoodId",
            1: "currentGoodId",
            2: "currentLikeId",
          };
          this[obj[orderType]] = res.data;
          if (res.data.length > 0) {
            this[obj1[orderType]] = res.data[0].id;
          }
        }
      });
    },
    /**查询首页租户 */
    pageHomeSchoolList() {
      return new Promise((resolve, reject) => {
        GetHomeTenant()
          .then((res) => {
            if (res.code == 200) {
              this.collegeList = res.data;
            }
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    /**屏幕监听 */
    listenSlider(){
      var width = window.innerWidth;
      if(width>750){
        if(this.timer){
          clearInterval(this.timer);
          this.timer=null;
          let rankBox=document.querySelector('.model-rank-box');
          rankBox.style.transform=`translateX(0px)`;
        }
      }else{
        if(!this.timer){
          this.autoSlider();
        }
      }
    }
  },
  mounted(){
    this.listenSlider();
    window.addEventListener('resize',this.listenSlider);
  },
  destroyed(){
    this.timer&&clearInterval(this.timer);
    this.timer=null;
    window.removeEventListener('resize',this.listenSlider);
  }
};
</script>

<style lang="less" scoped>
.rank-box {
  height: 77.5rem;
  background-image: url(../../assets/image/home/bg-003.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 9.5rem var(--padding) 0 var(--padding);
  margin-bottom: 25rem;
  .box-title {
    color: #151c34;
    font-size: 3.4rem;
    font-weight: 700;
    text-align: center;
    .title {
      margin-top: -5rem;
    }
  }
  .rank-slider{
    transform: translateY(10rem);
  }
  .model-rank-box {
    display: flex;
    justify-content: space-between;
    column-gap: 3rem;
    .left-rank {
      width: calc((100% - 6rem) / 3);
      background-color: #ffffff;
      min-height: 70rem;
      padding: 5rem 4rem;
      box-shadow: 0px 0px 8px 0px #eaf4ff;
      & > :nth-child(1) {
        text-align: center;
        .rank-title {
          font-size: 2.4rem;
          color: #151c34;
        }
        img {
          width: 10.8rem;
          object-fit: cover;
          margin-bottom: 6rem;
          margin-top: 2.5rem;
        }
      }
      .model-item {
        width: 100%;
        cursor: pointer;
        & > :nth-child(1) {
          display: flex;
          align-items: center;
          .rank {
            font-size: 2.4rem;
            font-weight: 700;
          }
          .rank-label {
            flex: 1;
            margin-left: 2.5rem;
            font-size: 16px;
            color: #334681;
          }
        }
        & > :nth-child(2) {
          margin: 3rem 0 3rem 6rem;
          .cover {
            width: 9rem;
            aspect-ratio: var(--aspectRatio);
            object-fit: cover;
          }
        }
      }
    }
  }
}
.rank0 {
  color: #ff2146;
}
.rank1 {
  color: #ff6410;
}
.rank2 {
  color: #ff913e;
}
.rank3,
.rank4 {
  color: #8590b3;
}
.collage-box {
  padding: 0 var(--padding) 11rem var(--padding);
  display: flex;
  flex-wrap: wrap;
  color: #334681;
  position: relative;
  .left-slider {
    width: 15rem;
    position: absolute;
    left: calc(var(--padding) - 2px);
    top: 0;
    height: 100%;
    z-index: 88;
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0.9),
      rgba(255, 255, 255, 0.6),
      rgba(255, 255, 255, 0)
    );
  }
  .right-slider {
    width: 15rem;
    background-image: linear-gradient(
      to left,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0.9),
      rgba(255, 255, 255, 0.6),
      rgba(255, 255, 255, 0)
    );
    position: absolute;
    right: calc(var(--padding) - 2px);
    top: 0;
    height: 100%;
  }
  .center-box {
    width: 100%;
    overflow: hidden;
    .college-box-item{
      display: flex;
      align-items: center;
      animation: translateX 15s linear infinite;
      .college-item {
        margin-left: 5rem;
        margin-top: 4rem;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        flex-shrink: 0;
        width: calc((100% - 16rem) / 9);
      img {
        width: 100%;
        height: auto;
        object-fit: cover;
        border-radius: 1rem;
      }
    }
    }
    & > :nth-child(8n + 1) {
      margin-left: 0;
    }
  }
}
@keyframes translateX{
  0%{
    transform: translateX(100%);
  }
  100%{
    transform: translateX(-100%);
  }
}
@keyframes slide-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes slide-out {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}

.slide-enter-active {
  animation: slide-in 0.3s;
}
.slide-leave-active {
  animation: slide-in 0.3s reverse;
}
.college-item {
  display: flex;
  align-items: center;
}
@media screen and (max-width:750px){
  .slider-spot{
  display: flex;
  justify-content: center;
  gap: 1rem;
  &> :nth-child(n){
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background-color: #BCC8DE;
    transform: translateY(9rem);
    cursor: pointer;
    transition: all 0.5s;
  }
}
.spot-active{
  background-color: var(--blue) !important;
  width: 2rem !important;
  border-radius: 1rem !important;
}
  .rank-box{
    height: auto;
    margin-bottom: 10rem;
    padding-top: 5rem;
    background-image: url(../../assets/image/phone/06.png) !important;
  }
  .rank-slider{
    width: 100%;
    overflow: hidden;
    transform: translateY(5rem) !important;
  }
  .model-rank-box{
    transition: all 1s;
    column-gap: 0 !important;
  }
  .left-rank{
    width: calc(100% - 16px) !important;
    flex-shrink: 0;
    margin: 8px;
  }
  .college-item{
    min-width: 10rem;
  }
}
</style>